import * as firebase from './firebase'

export default firebase
